import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-home-hero',
  templateUrl: './home-hero.component.html',
  styleUrls: ['./home-hero.component.scss']
})
export class HomeHeroComponent {
  @Input() quickStats: any[] = [];

  @Output() playVideoEvent = new EventEmitter<void>();

  playVideo(): void {
    this.playVideoEvent.emit();
  }
}